// extracted by mini-css-extract-plugin
export default {"durationInput":"DurationPicker_durationInput__HvMSJ"};